import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { Section, Eyebrow, H1, H2, Lead, ButtonPrimary, GlassCard } from "../components/ui-kit";

export default function About() {
  return (
    <div>
      <Section className="!pt-16">
        <Eyebrow>About Perforange</Eyebrow>
        <H1>Built to architect the <span className="text-gradient-orange">digital mind-sports</span> era.</H1>
        <Lead className="mt-6">
          Thousands of existing institutional computer labs sit underutilized across the country. We exist to transform them into world-class, health-regulated centers of performance and vocational growth.
        </Lead>
      </Section>

      {/* Story + Moat */}
      <Section className="!pt-0">
        <div className="grid md:grid-cols-2 gap-8">
          <GlassCard>
            <Eyebrow>Our Story</Eyebrow>
            <h3 className="font-display font-black text-2xl text-white mt-2">Hardware is easy. Soul is the real deliverable.</h3>
            <p className="mt-4 text-[#A1A1AA] leading-relaxed">
              Perforange was founded to bring rigorous, data-driven structure to the invisible hours students spend in unregulated digital environments. We recognized that while schools have invested heavily in elite ICT networks, these spaces lack the specialized ecosystem required to protect student health and channel raw talent. We engineered the platform to turn unmonitored screen time into institutional academic value.
            </p>
          </GlassCard>
          <GlassCard>
            <Eyebrow color="#00FFD0">The Moat</Eyebrow>
            <h3 className="font-display font-black text-2xl text-white mt-2">Asset-light by design.</h3>
            <p className="mt-4 text-[#A1A1AA] leading-relaxed">
              We don't sell boxes, PCs, or peripherals. We sell the syllabus, the trainers, the wellness audits, and the scouting pipeline. That keeps our margins fat, our deployments fast, and our alignment with government procurement honest.
            </p>
          </GlassCard>
        </div>
      </Section>

      {/* Leadership Statement */}
      <Section className="!pt-0">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#121216] via-[#0A0A0C] to-[#121216] border border-white/8 p-10 md:p-16" data-testid="leadership-statement">
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#FF8C00]/20 blur-3xl" />
          <Quote className="w-16 h-16 text-[#FF8C00]/30 mb-6" />
          <div className="grid md:grid-cols-12 gap-10 relative">
            <div className="md:col-span-12">
              <Eyebrow>Leadership & Vision</Eyebrow>
              <blockquote className="font-display font-bold text-xl sm:text-2xl md:text-[26px] leading-[1.45] tracking-tight text-[#E4E4E7]">
                &ldquo;A significant percentage of the modern student base engages in <span className="text-gradient-orange font-black">high-performance digital mind-sports</span> entirely unmonitored at home — leading to cognitive burnout and zero career direction.
                <br /><br />
                Perforange brings <span className="text-white font-black">structure</span> to this invisible footprint. Rather than requiring expensive hardware or real estate, our proprietary platform, <em className="text-[#FF8C00] not-italic font-black">Perforange OS</em>, deploys directly onto an institution&apos;s existing ICT networks to establish a <span className="text-[#00FFD0] font-black">health-safeguarded, credit-mapped developmental ecosystem</span>.
                <br /><br />
                Managed daily by school faculty and validated by our specialized Master Trainer network of veteran professionals, our platform tracks performance and wellness telemetry in real time.
                <br /><br />
                <span className="text-white font-black">We provide schools with an institutional framework that secures student digital wellness, optimizes existing laboratory assets, and formalizes unstructured hobbies into highly viable digital infrastructure careers.</span>&rdquo;
              </blockquote>
              <div className="mt-10 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#FF8C00] to-[#FF5A00] flex items-center justify-center text-[#0A0A0C] font-black text-xl">KM</div>
                <div>
                  <p className="font-display font-black text-white text-lg">Kinjal Mukherjee</p>
                  <p className="text-sm uppercase tracking-widest text-[#A1A1AA]">Founder, Perforange</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section className="!pt-0">
        <GlassCard className="md:flex items-center justify-between gap-6">
          <div>
            <H2 className="!text-3xl">Build with us.</H2>
            <p className="mt-3 text-[#A1A1AA]">Govt. partnerships, school empanelment, CSR alignment — one inbox.</p>
          </div>
          <Link to="/contact" data-testid="about-cta-contact">
            <ButtonPrimary className="mt-4 md:mt-0">Talk to Mission Control <ArrowRight className="w-4 h-4" /></ButtonPrimary>
          </Link>
        </GlassCard>
      </Section>
    </div>
  );
}
